// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607241106/js/" + chunkId + "." + {"44":"a39bf7d9","225":"5a74fbf1","481":"5073e7e0","486":"ce351f5b","770":"80a71573"}[chunkId] + ".0.8869573215734833.chunk.js";
};